export const newsLetter = function (el) {
    const submitForm = function () {
        const c = el.querySelector("[name='c']").value;
        const e = el.querySelector("[name='e']").value;

        const request = new XMLHttpRequest();
        request.open("POST", "/wp-admin/admin-ajax.php", true);
        request.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded"
        );

        console.log("request", request);

        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                const result = JSON.parse(this.response);
                console.log(result);
                el.querySelector(".newsletter__feedback").innerHTML =
                    result.feedback;
                if (result.success) {
                    el.querySelector("[name='e']").value = "";
                    el.querySelector(".newsletter__feedback").classList.remove(
                        "newsletter__feedback--error"
                    );
                    el.querySelector(".newsletter__feedback").classList.add(
                        "newsletter__feedback--success"
                    );
                } else {
                    el.querySelector(".newsletter__feedback").classList.add(
                        "newsletter__feedback--error"
                    );
                    el.querySelector(".newsletter__feedback").classList.remove(
                        "newsletter__feedback--success"
                    );
                }
            } else {
                alert("an error occurred (101)");
            }
        };

        request.onerror = function () {
            alert("an error occurred (102)");
        };

        request.send(`action=ajax_subscribe_to_newsletter&c=${c}&e=${e}`);
    };
    el.querySelector("[name='e']").addEventListener("keyup", function (evt) {
        if (evt.keyCode === 13) {
            submitForm();
        }
    });

    el.querySelector(".newsletter__button").addEventListener(
        "click",
        submitForm
    );
};
